<template>
  <v-toolbar
    :color="backgroundColor"
    dark
    class="toolbar-no-margin mb-0"
  >
    <v-btn
      v-if="back"
      icon
      class="hidden-xs-only"
      @click="$router.go(-1)"
    >
      <v-icon>mdi-arrow-left-circle</v-icon>
    </v-btn>

    <v-divider
      v-if="back"
      class="mx-4"
      inset
      vertical
    />

    <v-badge
      v-if="badgeIcon && badgeIcon !== '' && icon && icon !== ''"
      :color="backgroundColor"
      class="badge-over-right"
    >
      <template
        v-slot:badge
        style="left:-20px"
      >
        <v-icon
          dark
          small
        >
          {{ badgeIcon }}
        </v-icon>
      </template>
      <v-icon v-if="icon && icon !== ''">
        {{ icon }}
      </v-icon>
    </v-badge>
    <v-icon v-if="(!badgeIcon || badgeIcon === '') && icon && icon !== ''">
      {{ icon }}
    </v-icon>
    <v-avatar
      v-if="image && image !== ''"
      size="36px"
    >
      <v-img
        :src="image"
        width="40"
        height="40"
      />
    </v-avatar>
    <v-toolbar-title class="white--text pl-4">
      {{ title }}
    </v-toolbar-title>
    <v-spacer />
    <slot name="end-of-toolbar" />
    <v-progress-circular
      v-if="loading"
      indeterminate
      color="white"
      class="ml-2"
    />
  </v-toolbar>
</template>

<script lang="ts">
export default {
  name: 'MainTitle',
  props: {
    back: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: ''
    },
    image: {
      type: String,
      default: null
    },
    badgeIcon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: 'tertiary'
    }
  }
}
</script>
<style>
.v-badge.badge-over-right .v-badge__badge  {
    left: 15px;
}
</style>
